import {AnyAction} from '@reduxjs/toolkit'
import {AppDispatch} from 'store'

export const listenWindowEvent = (type: string, mapEventToAction: (event: Event) => AnyAction) => (dispatch: AppDispatch): () => void => {
    const listener = (event: Event) => {
        dispatch(mapEventToAction(event))
    }

    window.addEventListener(type, listener)

    return () => window.removeEventListener(type, listener)
}
